import React from "react";
import AccordionSection from "@profile/pages/AccountPage/components/AccordionSection/AccordionSection";
import Section from "../Section/Section";
import { Divider, Space, Typography } from "antd";
import FaqIcon from "./Faq.svg";

import * as styles from "./FaqStyle.module.scss";

type Props = {
  faq: {
    title: string;
    description: JSX.Element;
  }[];
};

const Faq = ({ faq }: Props) => (
  <div className={styles.faqWrapper}>
    <Section>
      <Space className={styles.faqLabel}>
        <FaqIcon />
        <Typography.Title level={5}>Common questions</Typography.Title>
      </Space>
      <Divider />
      {faq.length !== 0 && (
        <div className={styles.faqContainer}>
          {faq.map(({ title, description }) => (
            <AccordionSection
              key={title}
              mobileWidth={5600}
              clickableLabel
              label={title}
            >
              {description}
            </AccordionSection>
          ))}
        </div>
      )}
    </Section>
  </div>
);

export default Faq;
